import React from "react";
import GoogleButton from "../Login/GoogleButton";

const SocialLogin = () => {
  return (
    <>
      <div className="flex justify-between w-100 mt-2">
        <GoogleButton />
        {/* <button
                  disabled={loading}
                  type="submit"
                  className="flex items-center justify-center focus:outline-none text-slate-500 text-sm bg-slate-200 rounded-lg md:rounded md:py-2 px-3 py-3 w-full transition duration-150 ease-in"
                >
                  <FontAwesomeIcon icon={faGoogle} />
                  <span className="mr-2 flex-1">Login with Google</span>
                </button> */}
      </div>
      {/* <div className="flex justify-between w-full mt-3">
        <FacebookButton />
      </div> */}
      {/* <div className="flex justify-between w-full mt-2">
        <AppleLogin />
      </div> */}
      {/* End Social Button */}
    </>
  );
};

export default SocialLogin;
